var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("span", {
      staticClass: "price-start",
      domProps: { innerHTML: _vm._s(_vm.getPriceText) }
    }),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "more-price-info" }, [
      _vm._v(" \n    5 Nächte *"),
      _c("br")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }